<template>
  <div v-if="form">
    <form class="form-box">
      <b-container class="container-box">
        <b-row class="no-gutters">
          <b-col>
            <h1
              class="
                font-weight-bold
                header-main
                text-uppercase text-center text-sm-left
              "
            >
              {{ $t("returnDetails") }}
            </h1>
          </b-col>
        </b-row>

        <b-row class="no-gutters mt-2">
          <b-col>
            <div class="bg-white mb-2">
              <div class="row p-3">
                <div class="col-sm-6">
                  <p class="font-weight-bold text-center text-sm-left mb-2">
                    {{ $t("orderNo") }} :
                    <span class="font-weight-normal" style="padding-left: 25px">
                      <router-link :to="'/order/details/' + form.order.id">
                        <span
                          v-if="form.order.invoiceNo != ''"
                          class="text-underline"
                        >
                          {{ form.order.invoiceNo }}
                        </span>
                        <span v-else class="text-underline"
                          >{{ form.order.quotationNo }}
                        </span>
                      </router-link></span
                    >
                  </p>

                  <p class="font-weight-bold text-center text-sm-left mb-2">
                    {{ $t("date") }} / {{ $t("time") }} :
                    <span
                      class="font-weight-normal"
                      style="padding-left: 42px"
                      >{{
                        returnTime.createdTime == ""
                          ? "-"
                          : new Date(returnTime.createdTime)
                            | moment("DD MMM YYYY (HH:mm)")
                      }}</span
                    >
                  </p>
                </div>

                <div class="col-sm-6 text-center text-sm-right">
                  <p class="font-weight-bold text-center text-sm-right mb-2">
                    {{ $t("lastStatus") }} :
                    <span class="font-weight-normal pl-3">
                      {{ form.orderStatus }}
                    </span>
                  </p>

                  <p class="font-weight-bold text-center text-sm-right mb-2">
                    {{ $t("lastUpdated") }} :
                    <span class="font-weight-normal pl-3">{{
                      returnTime.updateTime == ""
                        ? "-"
                        : new Date(returnTime.updateTime)
                          | moment("DD MMM YYYY (HH:mm)")
                    }}</span>
                  </p>
                </div>
              </div>
            </div>

            <!-- รายละเอียด -->
            <b-row>
              <b-col md="12" class="text-lg-left">
                <div class="bg-white p-3 h-100">
                  <b-row>
                    <b-col md="4" class="border-detail">
                      <p class="font-weight-bold mb-2">
                        {{ $t("buyerInfo") }}
                      </p>
                      <div>
                        <b-row>
                          <b-col xl="4" class="font-weight-bold"
                            >{{ $t("name") }} :</b-col
                          >
                          <b-col class="mb-2 mb-sm-0" xl="8">
                            {{ form.order.firstname }} {{ form.order.lastname }}
                            <span
                              class="f-14 text-blue ml-3 text-underline"
                              @click="directToChat"
                              >{{ $t("sendMsg") }}</span
                            >
                          </b-col>

                          <b-col xl="4" class="font-weight-bold"
                            >{{ $t("tel") }} :</b-col
                          >
                          <b-col class="mb-2 mb-sm-0" xl="8">{{
                            form.order.telephone
                          }}</b-col>

                          <b-col xl="4" class="font-weight-bold"
                            >{{ $t("email") }} :</b-col
                          >
                          <b-col class="mb-2 mb-sm-0 text-wrap" xl="8">
                            {{ form.order.email }}</b-col
                          >

                          <b-col xl="4" class="font-weight-bold"
                            >{{ $t("tier") }} :</b-col
                          >
                          <b-col xl="8">{{ form.order.tier }}</b-col>
                        </b-row>
                      </div>
                    </b-col>
                    <b-col md="4" class="border-detail">
                      <p class="font-weight-bold mb-2">
                        {{ $t("detailAddress") }}
                      </p>
                      <div>
                        <b-row class>
                          <b-col class="my-2 mb-sm-0" md="12">
                            {{ form.order.shippingAddress.firstname }}
                            {{ form.order.shippingAddress.lastname }}
                          </b-col>

                          <b-col class="my-2 mb-sm-0" md="12">
                            {{ form.order.shippingAddress.address }}
                            {{ form.order.shippingAddress.building }}
                            {{ form.order.shippingAddress.alley }}
                            {{ form.order.shippingAddress.road }}
                            {{ form.order.shippingAddress.subDistrict }}
                            {{ form.order.shippingAddress.district }}
                            {{ form.order.shippingAddress.province }}
                            {{ form.order.shippingAddress.code }}</b-col
                          >

                          <b-col class="my-2 mb-sm-0" md="12"
                            >{{ $t("tel") }} :
                            {{ form.order.shippingAddress.telephone }}</b-col
                          >
                        </b-row>
                      </div>
                    </b-col>

                    <b-col md="4">
                      <p class="font-weight-bold mb-2">
                        {{ $t("detailReceipt") }}
                      </p>
                      <div>
                        <b-row class>
                          <b-col class="my-2 mb-sm-0" md="12"
                            >{{ form.order.billingAddress.firstname }}
                            {{ form.order.billingAddress.lastname }}</b-col
                          >

                          <b-col class="my-2 mb-sm-0" md="12">
                            {{ form.order.billingAddress.address }}
                            {{ form.order.billingAddress.building }}
                            {{ form.order.billingAddress.alley }}
                            {{ form.order.billingAddress.road }}
                            {{ form.order.billingAddress.subDistrict }}
                            {{ form.order.billingAddress.district }}
                            {{ form.order.billingAddress.province }}
                            {{ form.order.billingAddress.code }}</b-col
                          >

                          <b-col class="my-2 mb-sm-0" md="12"
                            >{{ $t("tel") }} :
                            {{ form.order.billingAddress.telephone }}</b-col
                          >
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <div class="bg-white mt-2">
              <b-row class="p-3">
                <b-col sm="4" class="text-center text-sm-left">
                  <p class="font-weight-bold my-2">
                    {{ $t("requestDetails") }}
                  </p>
                </b-col>
                <b-col class="text-center text-sm-right m-auto" sm="8">
                  <b-button
                    :disabled="form.returnStatusId != 1"
                    class="
                      btn-primary btn-details-set btn-main-primary
                      mr-1
                      btn-return
                    "
                    @click="updateReturnStatus(2)"
                  >
                    {{ $t("returnApproval") }}
                  </b-button>

                  <button
                    :disabled="form.returnStatusId != 1"
                    @click="updateReturnStatus(3)"
                    type="button"
                    class="
                      btn btn-outline-primary btn-details-set btn-main-reject
                      mr-1
                    "
                  >
                    {{ $t("refuseReturn") }}
                  </button>
                </b-col>
              </b-row>
            </div>

            <div class="bg-white mt-2">
              <div class="p-1">
                <div class="body-detail">
                  <div class="row no-gutters bg-gray-return py-3">
                    <div class="col-md-2 px-3">
                      <div
                        class="square-box"
                        v-bind:style="{
                          'background-image':
                            'url(' + form.orderItems[0].productImageUrl + ')',
                        }"
                      ></div>
                    </div>

                    <div class="col-6">
                      <div class>
                        <p class="font-weight-bold mb-1">
                          SKU: {{ form.orderItems[0].sku }}
                        </p>
                        <p class="m-0 two-lines">
                          {{ form.orderItems[0].productName }}
                        </p>
                        <div class="d-flex">
                          <div
                            v-for="(item, index) in form.orderItems[0]
                              .attribute"
                            :key="index"
                            class="config-tag mr-1 mt-1"
                          >
                            {{ item.label }} : {{ item.option.label }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 text-center">
                      <p
                        class="return-status"
                        v-if="form.orderItems[0].returnStatusId == 1"
                      >
                        {{ $t("inprogress") }}
                      </p>
                      <p
                        class="return-status"
                        v-if="form.orderItems[0].returnStatusId == 2"
                      >
                        {{ $t("approve") }}
                      </p>
                      <p
                        class="return-status"
                        v-else-if="form.orderItems[0].returnStatusId == 3"
                      >
                        {{ $t("reject") }}
                      </p>
                      <p
                        class="return-status"
                        v-else-if="form.orderItems[0].returnStatusId == 4"
                      >
                        {{ $t("returned") }}
                      </p>
                    </div>
                  </div>

                  <b-row class="p-3">
                    <b-col cols="12" class="text-left">
                      <p class="font-weight-bold mb-2">
                        {{ $t("detailsRequest") }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          form.orderItems[0].returnOrderProductImage.length != 0
                        "
                      >
                        {{ $t("imgReturnIlustration") }}
                      </p>

                      <div
                        v-bind:style="{
                          'background-image': 'url(' + item.path + ')',
                        }"
                        @click="showPreview(item.path)"
                        v-for="(item, index) in form.orderItems[0]
                          .returnOrderProductImage"
                        :key="index"
                        class="
                          img-doc
                          d-inline-block
                          mr-2
                          return-pic
                          pointer
                          my-3
                          b-contain
                        "
                      />

                      <p class="mb-1">
                        {{ $t("returnReason") }}:
                        <span v-if="form.orderItems[0].returnReason != null">{{
                          form.orderItems[0].returnReason
                        }}</span>
                        <span v-else>-</span>
                      </p>

                      <p class="mb-1">
                        {{ $t("note") }}:
                        <span v-if="form.orderItems[0].note != null">{{
                          form.orderItems[0].note
                        }}</span>
                        <span v-else>-</span>
                      </p>
                      <!-- <p class="mb-1">{{ $t("details") }}: {{form.orderItems[0].}}</p> -->
                    </b-col>
                  </b-row>

                  <hr class="m-0" />

                  <b-row class="p-3">
                    <b-col cols="12" md="6" class="text-left">
                      <p class="font-weight-bold mb-2">
                        {{ $t("returnDetails") }}
                      </p>

                      <!-- รูปประกอบการคืน -->

                      <label
                        class="mb-1"
                        v-if="form.returnOrderDetailImage.length != 0"
                      >
                        {{ $t("returnIllustration") }}:
                      </label>
                      <span v-else>-</span>
                      <br />
                      <div
                        v-bind:style="{
                          'background-image': 'url(' + item.path + ')',
                        }"
                        @click="showPreview(item.path)"
                        v-for="(item, index) in form.returnOrderDetailImage"
                        :key="index"
                        class="
                          img-doc
                          d-inline-block
                          mr-2
                          return-pic
                          pointer
                          my-3
                          b-contain
                        "
                      />
                      <br />

                      <!-- ขนส่งที่เลือกส่งคืน -->
                      <label>
                        {{ $t("transport") }}:
                        <span v-if="form.shippingType != null">{{
                          form.shippingType
                        }}</span>
                        <span v-else>-</span>
                      </label>
                      <br />

                      <!-- เลขติดตามพัสดุ -->
                      <label>
                        {{ $t("tracking") }}:
                        <span v-if="form.trackingNumber != null">{{
                          form.trackingNumber
                        }}</span>
                        <span v-else>-</span>
                      </label>
                      <br />
                    </b-col>

                    <b-col v-if="false" cols="12" md="6" class="text-left">
                      <p class="font-weight-bold mb-2">
                        {{ $t("moneyTransferDetails") }}
                      </p>

                      <!-- บัญชีธนาคารรับเงิน -->
                      <label>
                        {{ $t("bankAccount") }}:
                        <span v-if="form.bankName != null">{{
                          form.bankName
                        }}</span>
                        <span v-else>-</span>
                      </label>
                      <br />

                      <!-- เลขบัญชีธนาคาร -->
                      <label>
                        {{ $t("bankAccountNumber") }}:
                        <span v-if="form.bankAccountNo != null">{{
                          form.bankAccountNo
                        }}</span>
                        <span v-else>-</span>
                      </label>
                      <br />

                      <!-- ชื่อบัญชีรับเงิน -->
                      <label>
                        {{ $t("bankAccountName") }}:
                        <span v-if="form.bankAccountName != null">{{
                          form.bankAccountName
                        }}</span>
                        <span v-else>-</span>
                      </label>
                      <br />

                      <!-- หลักฐานการโอนคืน -->
                      <div class="row">
                        <div class="col-6">
                          <p class="font-weight-bold mb-2 pt-1">
                            {{ $t("proofOfTransfer") }}
                          </p>
                        </div>
                        <div class="col-6" v-if="form.orderStatusId == 4">
                          <p class="text-right">
                            <a
                              class="btn-a"
                              @click="addViewDetailTransfer('add')"
                            >
                              {{ $t("transferMoney") }}
                            </a>
                          </p>
                        </div>
                      </div>

                      <!-- หลักฐานการโอน -->
                      <label>
                        {{ $t("proofOfTransfer") }}:
                        <span
                          v-if="form.slipImage && form.slipImage.length > 0"
                        >
                          <a
                            class="btn-a"
                            @click="addViewDetailTransfer('view')"
                            >{{ $t("viewDetail") }}</a
                          >
                          <a
                            class="btn-a pl-2"
                            @click="downloadSlipImageTransfer()"
                            >{{ $t("download") }}</a
                          >
                        </span>
                        <span v-else>{{ $t("noData") }}</span>
                      </label>
                      <br />

                      <!-- จำนวนเงินที่โอน -->
                      <label>
                        {{ $t("transferAmount") }}:
                        <span v-if="form.payBackValue">
                          ฿ {{ form.payBackValue | numeral("0,0.00") }}
                        </span>
                        <span v-else>-</span>
                      </label>
                      <br />

                      <!-- อัพเดทล่าสุด -->
                      <label>
                        {{ $t("lastUpdate") }}:

                        <span>{{
                          form.slipUpdatedTime == "0001-01-01T00:00:00"
                            ? "-"
                            : new Date(form.slipUpdatedTime)
                              | moment("DD MMM YYYY (HH:mm)")
                        }}</span>
                      </label>
                      <br />
                    </b-col>
                  </b-row>
                  <div class="px-3">
                    <b-row class="py-3">
                      <b-col class="m-auto" sm="12">
                        <b-button
                          :disabled="form.orderStatusId != 7"
                          class="
                            btn-primary btn-details-set btn-main-primary
                            mr-1
                            btn-return
                          "
                          @click="clickConfirmRejectReturn(`confirm`)"
                        >
                          {{ $t("confirmation") }}
                        </b-button>

                        <button
                          :disabled="form.orderStatusId != 7"
                          type="button"
                          class="
                            btn
                            btn-outline-primary
                            btn-details-set
                            btn-main-reject
                            mr-1
                          "
                          @click="clickConfirmRejectReturn(`reject`)"
                        >
                          {{ $t("reject") }}
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <div class="px-3">
                <InputTextArea
                  class="mb-4"
                  :textFloat="$t('saveReplyRequest')"
                  :placeholder="$t('saveReplyRequest')"
                  type="text"
                  name="answer"
                  rows="5"
                  v-model="note"
                />

                <b-row class="no-gutters pb-3">
                  <b-col md="4">
                    <router-link to="/return">
                      <button
                        :disabled="isDisable"
                        @click="updateReturnStatus(3)"
                        type="button"
                        class="
                          btn
                          btn-outline-primary
                          btn-details-set
                          btn-main-reject
                          mr-1
                        "
                      >
                        {{ $t("cancel") }}
                      </button>
                    </router-link>
                  </b-col>
                  <b-col md="8" class="text-sm-right">
                    <button
                      :disabled="isDisable"
                      type="button"
                      class="
                        btn btn-details-set btn-main-primary
                        ml-md-2
                        text-uppercase
                      "
                      @click="updateReturnStatus(form.returnStatusId)"
                    >
                      {{ $t("save") }}
                    </button>
                  </b-col>
                </b-row>
              </div>
              <div>
                <b-table
                  striped
                  responsive
                  hover
                  :items="form.returnOrderStatusLogs"
                  :fields="fieldsLog"
                  show-empty
                  :empty-text="$t('noData')"
                  class="table-list"
                >
                  <template v-slot:cell(createdTime)="data">
                    <span>{{
                      new Date(data.item.createdTime)
                        | moment("DD MMM YYYY (HH:mm)")
                    }}</span>
                  </template>
                  <template v-slot:cell(firstname)="data">
                    {{ data.item.firstname }} {{ data.item.lastname }}
                  </template>
                  <template v-slot:cell(note)="data">
                    <div v-if="data.item.note == '' || data.item.note == null">
                      -
                    </div>
                    <div v-else>{{ data.item.note }}</div>
                  </template>
                </b-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </form>

    <b-modal
      id="showPreviewModal"
      ref="showPreviewModal"
      hide-header
      hide-footer
      centered
      body-class="p-4"
      size="md"
    >
      <div class="modal-header border-0 px-0 pt-0">
        <!-- <h3 class="font-weight-bold">Image Preview</h3> -->
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('showPreviewModal')"
        >
          ×
        </button>
      </div>
      <div>
        <b-container class="p-0">
          <b-row>
            <b-col>
              <div
                class="preview-box b-contain m-auto border-0"
                v-bind:style="{ 'background-image': 'url(' + img + ')' }"
              ></div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal
      id="showBookBankModal"
      ref="showBookBankModal"
      hide-header
      hide-footer
      centered
      body-class="p-4"
      size="md"
    >
      <div class="modal-header border-0 px-0 pt-0">
        <h3 class="font-weight-bold">{{ $t("bookBank") }}</h3>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('showBookBankModal')"
        >
          ×
        </button>
      </div>
      <div>
        <b-container class="p-0">
          <b-row>
            <b-col>
              <div
                class="preview-box b-contain m-auto border-0"
                v-bind:style="{
                  'background-image': 'url(' + form.bookBankImageUrl + ')',
                }"
              ></div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <!-- หลักฐานการโอน -->
    <b-modal
      id="showTransferProofModal"
      ref="showTransferProofModal"
      hide-header
      hide-footer
      centered
      body-class="p-4"
      size="md"
    >
      <div class="modal-header border-0 px-0 pt-0">
        <h3 class="font-weight-bold">
          {{
            modeTransfer === "add"
              ? $t("areYouSureYouWantToConfirmReceiptOfTheProduct")
              : $t("viewDetailsOfProofOfTransfer")
          }}
        </h3>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('showTransferProofModal')"
        >
          ×
        </button>
      </div>
      <div>
        <b-container class="p-0">
          <b-row>
            <b-col>
              <div>
                <UploadFile
                  v-if="modeTransfer === 'add'"
                  :textFloat="$t('proofOfTransfer')"
                  :placeholder="$t('pleaseUpload')"
                  format="image"
                  name="imageUrl"
                  :fileName="transferProof.imageUrl"
                  :text="$t('feedImgRequire')"
                  v-on:onFileChange="onImageChange"
                  v-on:delete="deleteImage"
                  isRequired
                  :isValidate="$v.transferProof.imageUrl.$error"
                  :v="$v.transferProof.imageUrl"
                />

                <InputText
                  :disabled="modeTransfer !== 'add'"
                  :textFloat="$t('transferAmount')"
                  :placeholder="$t('transferAmount')"
                  type="number"
                  name="payBack"
                  v-model="transferProof.payBack"
                  isRequired
                  :isValidate="$v.transferProof.payBack.$error"
                  :v="$v.transferProof.payBack"
                />
              </div>
              <div
                class="preview-box"
                v-bind:style="{
                  'background-image': 'url(' + showPreviewTransferProof + ')',
                }"
              >
                <img
                  src="@/assets/images/icons/loading.svg"
                  class="loading"
                  alt="loading"
                  v-if="isLoadingImage"
                />
              </div>
              <div class="row" v-if="modeTransfer === 'add'">
                <div class="col-6">
                  <b-button
                    class="btn-outline-primary btn-main-reject"
                    @click="$bvModal.hide('showTransferProofModal')"
                  >
                    {{ $t("cancel") }}
                  </b-button>
                </div>
                <div class="col-6 text-end">
                  <b-button
                    class="btn-primary btn-main-primary btn-return"
                    @click="transferProofSubmit()"
                  >
                    {{ $t("submit") }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlertConfirm
      :msg="modalMsg"
      :text="modalMessageConfirm"
      colorBtnConfirm="primary"
      :btnCancel="modalBtnCancel"
      :btnConfirm="modalBtnConfirm"
      :isRemark="isRemark"
      :labelRemark="labelRemark"
      :placeholderRemark="placeholderRemark"
      ref="isModalAlertConfirm"
      @confirm="callbackModalAlertConfirm"
    />
  </div>
</template>

<script>
import sampleImg from "@/assets/images/cinna.jpg";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlertConfirm from "./components/ModalAlertConfirm";
import UploadFile from "@/components/inputs/UploadFile";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ReturnDetails",
  components: {
    InputTextArea,
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    ModalAlertConfirm,
    UploadFile,
  },
  validations: {
    transferProof: {
      imageUrl: { required },
      payBack: { required },
    },
  },
  data() {
    return {
      sample: sampleImg,
      id: this.$route.params.id,
      selected: [],
      showPreviewTransferProof: "",
      isLoadingImage: false,
      selectedAll: false,
      isDisable: false,
      isRemark: false,
      modalMsg: "",
      modalMessageConfirm: "",
      modalMessage: "",
      modalBtnConfirm: "",
      modalBtnCancel: "",
      labelRemark: this.$t("ระบุเหตุผลการปฏิเสธ"),
      placeholderRemark: this.$t("ระบุเหตุผลของการปฏิเสธสินค้า"),
      form: null,
      note: "",
      img: "",
      isCallback: "",
      modeTransfer: "add",
      fieldsLog: [
        {
          key: "createdTime",
          label: `${this.$t("dateTime")}`,
          class: "w-100px",
        },
        {
          key: "returnOrderStatus",
          label: `${this.$t("status")}`,
          class: "w-100px",
        },
        {
          key: "firstname",
          label: `${this.$t("updateBy")}`,
          class: "w-100px",
        },
        {
          key: "note",
          label: `${this.$t("note")}`,
          class: "w-100px",
        },
      ],
      returnTime: {
        createdTime: "",
        updateTime: "",
      },
      imgTypeId: 28,
    };
  },
  created: async function() {
    await this.getData();
    this.$isLoading = true;
  },
  methods: {
    directToChat() {
      this.$store.commit("setOtherProfile", this.form);
      setTimeout(() => {
        this.$router.push({
          path: "/chat",
        });
      }, 500);
    },
    showPreview(img) {
      this.img = img;
      this.$refs["showPreviewModal"].show();
    },
    getData: async function() {
      this.isBusy = true;
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/Transaction/ReturnOrder/` + this.id,
        null,
        this.$headers,
        null
      );
      if (resData.result == 1) {
        this.form = resData.detail;
        this.transferProof = {
          fileName: "",
        };
        // console.log(`this.form `, this.form);
        // returnOrderDetailImage

        if (this.form.bookBankImageUrl)
          this.form.returnOrderDetailImage.push({
            id: this.form.returnOrderDetailImage.length + 1,
            path: this.form.bookBankImageUrl,
          });

        // if (this.form.slipImage)
        //   this.form.slipImage.push({
        //     id: this.form.returnOrderDetailImage.length + 1,
        //     path: this.form.bookBankImageUrl,
        //   });
        if (this.form.returnOrderStatusLogs.length) {
          this.returnTime.createdTime = this.form.returnOrderStatusLogs[
            this.form.returnOrderStatusLogs.length - 1
          ].createdTime;
          this.returnTime.updateTime = this.form.returnOrderStatusLogs[0].createdTime;
        }

        this.isBusy = false;
        this.$isLoading = true;
      }
    },
    updateReturnStatus: async function(id) {
      this.isDisable = true;

      this.$refs.modalLoading.show();

      let data = {
        id: this.form.id,
        orderId: this.form.orderId,
        note: this.note,
        orderItems: [
          {
            productId: this.form.productId,
            returnOrderId: this.form.returnOrderId,
          },
        ],
        orderStatusId: id,
      };

      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Transaction/ReturnOrder/save`,
        null,
        this.$headers,
        data
      );
      this.modalMessage = resData.message;
      this.isDisable = false;
      this.$refs.modalLoading.hide();
      this.$store.dispatch("getActiveData");
      if (resData.result == 1) {
        this.$refs.modalAlert.show();
        setTimeout(() => {
          this.$refs.modalAlert.hide();
        }, 3000);
        this.note = "";
        this.getData();
      } else {
        this.$refs.modalAlertError.show();
      }
    },
    clickConfirmRejectReturn(status) {
      console.log(`status`, status);
      // cancel
      if (status === "confirm") {
        this.modalMessageConfirm = this.$t(`msgAlertComfirmReturn`);
        this.modalMsg = this.$t("msgComfirmReturn");
        this.modalBtnConfirm = this.$t("msgConfirmReceiptReturn");
        this.isRemark = false;
      } else if (status === "reject") {
        this.modalMessageConfirm = this.$t(`msgAlertComfirmRejectReturn`);
        this.modalMsg = this.$t("msgComfirmRejectReturn");
        this.modalBtnConfirm = this.$t("msgConfirmReceiptRejectReturn");
        this.isRemark = true;
      }
      // modalBtnConfirm: "",
      this.modalBtnCancel = this.$t("cancel");
      this.isCallback = "ConfirmReject";
      this.$refs.isModalAlertConfirm.show();
    },
    callbackModalAlertConfirm: async function(remark) {
      try {
        if (!this.isRemark) {
          await this.updateReturnStatus(10);
          this.$refs.isModalAlertConfirm.hide();
        } else if (this.isRemark && remark) {
          const res = await this.$callApi(
            "post",
            `${this.$baseUrl}/api/Transaction/ReturnOrder/RejectReturning`,
            null,
            this.$headers,
            {
              id: this.form.id,
              orderId: this.form.orderId,
              rejectingReason: remark,
            }
          );

          console.log(`res`, res);
          if (res.result == 1) {
            this.modalMessage = res.detail;
            this.$refs.modalAlert.show();
            this.$refs.isModalAlertConfirm.hide();
            await this.getData();
            setTimeout(() => {
              this.$refs.modalAlert.hide();
            }, 3000);
          } else {
            this.modalMessage = res.message;
            this.$refs.modalAlertError.show();
          }
        }
      } catch (error) {
        this.modalMessage = "มีบางอย่างผิดพลาดไม่สามารถบันทึกได้ !!";
        this.$refs.modalAlertError.show();
      }
    },
    onImageChange(img) {
      // console.log(`img`, img);

      this.transferProof.fileName = img.name;
      this.transferProof.type = img.type;

      this.isLoadingImage = true;
      this.isDisable = true;

      var reader = new FileReader();
      reader.readAsDataURL(img);

      reader.onload = async () => {
        this.images = await this.saveImagetoDb(reader.result);
        this.isLoadingImage = false;
        this.isDisable = false;

        this.showPreviewTransferProof = this.images;
        this.transferProof.imageUrl = this.images;
      };
    },
    saveImagetoDb: async function(img) {
      var imgData = {
        base64: img,
        type: this.imgTypeId,
      };
      // console.log(`imgData`, imgData);
      this.transferProof.imageData = imgData;

      // return this.transferProof.imageData.base64;

      let data = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/image/save`,
        null,
        this.$headers,
        imgData
      );

      if (data.result == 1) {
        return data.detail.url;
      }
    },
    deleteImage(value) {
      // console.log(`value`, value);
      this.transferProof.imageUrl = "";
      this.transferProof.imageBase64 = null;
      this.showPreviewTransferProof = null;

      if (this.coverImgType == 2) {
        var vid = this.$refs.videoRef;
        vid.load();
        this.coverImgType = 1;
      }
    },
    transferProofSubmit: async function() {
      try {
        this.$v.transferProof.$touch();

        if (this.$v.transferProof.$error) return;
        this.$refs.modalLoading.show();

        console.log(`transferProof`, this.transferProof);
        const model = {
          id: this.form.id,
          orderId: this.form.orderId,
          payBack: Number(this.transferProof.payBack),
          slipImageUrl: this.transferProof.imageData.base64,
        };

        let data = await this.$callApi(
          "post",
          `${this.$baseUrl}/api/Transaction/ReturnOrder/ConfirmPayBack`,
          null,
          this.$headers,
          model
        );
        // console.log(`data`, data);
        this.$bvModal.hide("showTransferProofModal");
        this.modalMessage = data.detail;
        this.$refs.modalAlert.show();
        setTimeout(() => {
          this.$refs.modalAlert.hide();
        }, 3000);
        await this.getData();
        this.$refs.modalLoading.hide();
      } catch (error) {
        this.$refs.modalLoading.hide();
      }
    },
    addViewDetailTransfer(mode) {
      this.modeTransfer = mode;
      if (mode !== "add") {
        if (this.form.slipImage.length > 0) {
          this.showPreviewTransferProof = this.form.slipImage[0].path;
          this.transferProof.payBack = this.form.payBackValue;
        }
      } else {
        this.showPreviewTransferProof = null;
        this.transferProof.payBack = null;
      }

      this.$bvModal.show("showTransferProofModal");
    },
    downloadSlipImageTransfer: async function() {
      if (this.form.slipImage.length > 0) {
        const obj = this.form.slipImage[this.form.slipImage.length - 1];
        if (obj.path) {
          const pathFile = obj.path;
          this.$refs.modalLoading.show();
          if (
            obj.path.split(".").pop() == "jpg" ||
            obj.path.split(".").pop() == "png"
          ) {
            await this.downloadImage(obj.path);
          } else {
            axios({
              url: pathFile,
              method: "GET",
              headers: null,
              responseType: "blob",
            }).then(response => {
              this.$refs.modalLoading.hide();
              var fileURL = window.URL.createObjectURL(
                new Blob([response.data])
              );
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("crossOrigin", "anonymous");
              fileLink.setAttribute("download", `${path.split("/").pop()}`);
              document.body.appendChild(fileLink);
              fileLink.click();
            });
          }
        }
      }
    },
    downloadImage: async function(path) {
      this.$nextTick(() => {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.src = path + "?time=" + new Date().valueOf();

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          this.dataURL = canvas.toDataURL();

          var fileLink = document.createElement("a");
          fileLink.href = this.dataURL;
          fileLink.setAttribute("crossOrigin", "anonymous");
          fileLink.setAttribute("download", `${path.split("/").pop()}`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        };
      });
    },
  },
};
</script>

<style scoped>
.review-shortdesc {
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
}
.text-grey {
  color: gray;
}

.text-underline {
  color: #007bff !important;
}

/* .return-pic {
  width: 15% !important;
  padding-bottom: 15% !important;
} */

.border-detail {
  border-right: 1px solid #ccc;
  /* margin-right: 30px; */
}

@media (max-width: 751px) {
  .border-detail {
    border-right: 0px solid #ccc;
    border-bottom: 1px solid #ccc;
    margin-right: 0px;
    padding-bottom: 10px;
  }
}

.return-status {
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}

div {
  word-break: break-word;
}

.config-tag {
  background: #ff0641;
  padding: 1px 5px;
  color: white;
  border-radius: 15px;
  font-size: 12px;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .btn-return {
    /* width: 100px !important; */
  }
}

.btn-main-reject {
  min-width: 185px;
  font-weight: bold;
  text-transform: uppercase;
  background-color: #ffffff;
}

.btn-main-reject:hover {
  color: #007bff;
  border-color: #007bff;
}

.btn-main-primary {
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
  min-width: 185px;
  font-weight: bold;
  text-transform: uppercase;
}

.btn-main-primary:hover {
  color: #fff;
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

.square-ratio-pt {
  width: 100px !important;
  padding-top: 25% !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #8d8d8d;
  background-color: transparent;
  cursor: no-drop;
}

.body-detail {
  background-color: #f1f1f1;
  border: 2px solid #dbdbdb80;
  margin: 10px;
}

.img-doc {
  width: 100px;
  height: 100px;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  cursor: no-drop;
}
.btn-a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  text-decoration: underline;
}
.btn-a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.btn-modal {
  width: 140px;
  font-weight: bold;
}

.text-end {
  text-align: end;
}

.square-box {
  width: 100%;
  padding-top: 100%;
}
</style>
